import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const cerrarMenu = () => setMenuAbierto(false);

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={cerrarMenu}>
            <img src="/assets/bh_logo.png" alt="BH La Marca del Panadero" />
          </Link>
        </div>

        <button
          className={`hamburger ${menuAbierto ? 'open' : ''}`}
          onClick={() => setMenuAbierto(!menuAbierto)}
          aria-label="Menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${menuAbierto ? 'open' : ''}`}>
          <ul>
            <li><Link to="/" onClick={cerrarMenu}>Inicio</Link></li>
            <li><Link to="/productos" onClick={cerrarMenu}>Nuestras máquinas</Link></li>
            <li><a href="/#about-us-section" onClick={cerrarMenu}>Sobre Nosotros</a></li>
            <li>
              <a
                href="https://wa.me/5491140882236?text=Hola%2C%20necesito%20servicio%20t%C3%A9cnico"
                target="_blank"
                rel="noopener noreferrer"
                onClick={cerrarMenu}
                className="nav-wsp"
              >
                Servicio Técnico
              </a>
            </li>
            <li><a href="/#contact-section" onClick={cerrarMenu}>Contacto</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
